import { render, staticRenderFns } from "./TwoFactorSetup.vue?vue&type=template&id=4f67f52c&scoped=true"
import script from "./TwoFactorSetup.vue?vue&type=script&lang=js"
export * from "./TwoFactorSetup.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorSetup.vue?vue&type=style&index=0&id=4f67f52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f67f52c",
  null
  
)

export default component.exports